'use strict';

import autocomplete from 'devbridge-autocomplete'; // eslint-disable-line no-unused-vars
import Backbone from 'backbone';
import _ from 'underscore';
import $ from 'jquery';
import config from '../../../js/config';
import { pluraliseAndTranslate } from '../../../utilities/globalisation';
import utilities from '../../../js/utilities';
import UrlDataModel from '../../Search/urlModel';
import parametricValue from '../templates/_AdvancedSearchParametric.hbs'
import Analytics from '../../Analytics/Analytics';

const disabledLabel = `${config.classes.advancedSearchDisabledLabel}`;

export default class AdvancedSearchController extends Backbone.View {
  initialize(options = {}) {
    _.extend(this, options);

    this.maxParams = 5;

    this.initializeElements();
  }

  initializeElements() {

    this.createValidator();
    this.parametricValuesArr = [];
    this.parametricElement = 1;
    this.createNewParametric();
    this.$clearCategory.hide();
    this.$clearManufacturer.hide();
    this.$clearCategoryAutoComplete.hide();
    this.$clearManufacturerAutoComplete.hide();
    this.$advMoreParametrics.hide();
    this.initializeEvents();
    this.chosenManufacturerArray = [];
    this.$advancedSearchManufacturerContainer.hide();
    this.$arrowsManufacturerAutoComplete.show();
    this.$includeManufacturerCheckbox.prop('disabled', true);

    this.$manufacturerList.autocomplete({
      minLength: 0,
      minChars: 0,
      autoSelectFirst: false,
      zIndex: 10000,
      preserveInput: true,
      lookupFilter: ((suggestion, originalQuery, queryLowerCase) => {
        let term = queryLowerCase.split(/,\s*/).pop();
        let re = new RegExp('\\b' + $.Autocomplete.utils.escapeRegExChars(term), 'gi');
        return re.test(suggestion.value);
      }),
      onSelect: ((suggestion) => {
        let found = 0;
        for (let i = 0; i < this.chosenManufacturerArray.length; i++) {
          if (this.chosenManufacturerArray[i].data === suggestion.data) {
            found = 1;
            break;
          }
        }
        if (!found) {
          this.chosenManufacturerArray.push(suggestion);
          let terms = this.$manufacturerList.val().split(/,\s*/);
          terms.pop();
          terms.push(suggestion.name);
          terms.push('');
          this.$manufacturerList.val(terms.join(', '));
          this.validateForm();
          this.toggleManufacturerAutoCompleteControls();
        }
        this.modelData = new UrlDataModel({ apiUrlString: 'cat=' + this.chosenCategory });
        if (this.chosenManufacturerArray.length > 0 &&
          (this.chosenCategory === undefined || this.chosenCategory === '')) {
          this.$categoryList.prop('disabled', true);
          let manufacturerIdArray = _.pluck(this.chosenManufacturerArray, 'data');
          this.loadFilteredCategoryResult(manufacturerIdArray.join('|'));
        }
        this.verifyManufacturerStatusFilter();
        this.sendAnalytics(suggestion.name, config.analytics.eventTypes.Click, config.analytics.categoryTypes.AdvancedSearch, config.analytics.actions.ManufacturerAnalyticsSelectedTerm);
        this.$manufacturerList.focus();
      }),
      onHint: ((hint) => {
        $('#AdvSearchCategoriesManufacturerx').val(hint);
      }),
      onHide: (() => {
        $('#AdvSearchCategoriesManufacturer').removeAttr('aria-activedescendant');
        $('#AdvSearchCategoriesManufacturer').removeAttr('aria-describedby');
        $('#AdvSearchCategoriesManufacturer').attr('aria-expanded', false);
      }),
      beforeRender: ((container) => {
        container[0].id = 'AdvSearchCategoriesManufacturerAutocomplete';
        container.attr('role', 'listbox');
        container.attr('aria-hidden', true);
      }),
      onSearchComplete: (() => {
        try {
          let container = document.getElementById($('#AdvSearchCategoriesManufacturer').attr('aria-owns'));
          if (container) {
            for (var i = 0; i < container.children.length; i++) {
              container.children[i].id = container.id + '' + i;
              container.children[i].setAttribute('role', 'option');
            }
            $('#AdvSearchCategoriesManufacturer')[0].suggestionsContainer = container;
            $('#AdvSearchCategoriesManufacturer').attr('aria-expanded', true);
          }
        } catch (e) {
          console.log(e.message);
        }
      })
    });

    this.$categoryList.autocomplete({
      minLength: 0,
      minChars: 0,
      autoSelectFirst: false,
      zIndex: 10000,
      lookupFilter: ((suggestion, originalQuery, queryLowerCase) => {
        let matchFound = suggestion.value.toLowerCase().startsWith(queryLowerCase);
        if (!matchFound && suggestion.dependentSuggestions && suggestion.dependentSuggestions.length > 0) {
          matchFound = _.some(suggestion.dependentSuggestions, (subItem) => (subItem.searchParameter.toLowerCase().startsWith(queryLowerCase)));
        }
        return matchFound;
      }),
      onSelect: ((suggestion) => {
        let inputText = document.getElementById('AdvSearchCategoriesCategory').value;
        if (inputText) {
          this.$includeManufacturerCheckbox.prop('disabled', false);
          document.getElementById('AdvParametricHint').style.display = 'none';
        } else {
          document.getElementById('AdvParametricHint').style.display = 'block';
        }
        this.validateForm();
        let manufacturerValue = this.$manufacturerList.val();
        let manufacturerFilter = '';

        if (manufacturerValue !== undefined && manufacturerValue !== null && manufacturerValue !== '') {
          manufacturerValue = manufacturerValue.replace(/,/g, '');
          manufacturerValue = manufacturerValue.trim();
          manufacturerFilter = config.events.search.filterString + config.events.search.manufacturerFilter + manufacturerValue.replace(' ', '+') + ';';
        }

        this.chosenCategory = suggestion.data;
        this.chosenCategoryType = suggestion.categoryType;
        this.$categoryList.val(suggestion.value);
        this.modelData = new UrlDataModel({ apiUrlString: 'cat=' + this.chosenCategory + manufacturerFilter });
        this.toggleCategoryAutoCompleteControls();
        if (this.chosenCategoryType === '3') {
          this.modelData = new UrlDataModel({ apiUrlString: 'prodLine=' + this.chosenCategory + manufacturerFilter });
        }

        if (this.chosenCategory !== undefined && this.chosenCategory !== null && this.chosenCategory !== '' && manufacturerValue !== undefined && manufacturerValue !== null && manufacturerValue === '') {
          this.$manufacturerLabel.text(pluraliseAndTranslate('productSearch', 'advancedSearchManufacturerForCategory') + ' ' + this.chosenCategory);
          this.$manufacturerList.prop('disabled', true);
          this.$manufacturerForCategoryLabel.show();
          this.loadFilteredManufacturersAndParametersResult();
        }
        else if (manufacturerValue !== undefined && manufacturerValue !== '') {
          this.loadFilteredParametersResult();
        }
        this.sendAnalytics(suggestion.name, config.analytics.eventTypes.Click, config.analytics.categoryTypes.AdvancedSearch, config.analytics.actions.CategoryAnalyticsSelectedTerm);
      }),
      onHint: ((hint) => {
        $('#AdvSearchCategoriesCategoryx').val(hint);
      }),
      onHide: (() => {
        $('#AdvSearchCategoriesCategory').removeAttr('aria-activedescendant');
        $('#AdvSearchCategoriesCategory').removeAttr('aria-describedby');
        $('#AdvSearchCategoriesCategory').attr('aria-expanded', false);
      }),
      beforeRender: ((container) => {
        container[0].id = 'AdvSearchCategoriesCategoryAutocomplete';
        container.attr('role', 'listbox');
        container.attr('aria-hidden', true);
      }),
      onSearchComplete: (() => {
        try {
          let container = document.getElementById($('#AdvSearchCategoriesCategory').attr('aria-owns'));
          if (container) {
            for (var i = 0; i < container.children.length; i++) {
              container.children[i].id = container.id + '' + i;
              container.children[i].setAttribute('role', 'option');
            }
            $('#AdvSearchCategoriesCategory')[0].suggestionsContainer = container;
            $('#AdvSearchCategoriesCategory').attr('aria-expanded', true);
          }
        } catch (e) {
          console.log(e.message);
        }
      }),
      formatResult: ((suggestion, currentValue) => {
        if (suggestion.categoryType === '1' && currentValue && suggestion.data.toLowerCase().startsWith(currentValue)) {
          return '<div class="autocomplete-category-match">' + suggestion.value + '</div>';
        } else if (suggestion.categoryType === '3') {
          return '<div class="autocomplete-category">' + suggestion.value + '</div>';
        }
        else {
          return '<div class="autocomplete-category-no-match">' + suggestion.title + '</div>';
        }
      })
    });

    this.$categoryList.prop('disabled', true);
    this.$manufacturerList.prop('disabled', true);
    this.resetStatusBoxes();
    document.getElementById('ParametricSearchModalDialog').focus();
  }

  validateForm() {
    let ValidForm = this.instance.$form.validate().checkForm();
    if (this.$categoryList.val()) {
      $('#AdvSearchCategoriesCategory-error').remove();
    }
    if (!$('#IncludeManufacturer').is(':checked') || this.$manufacturerList.val()) {
      $('#AdvSearchCategoriesManufacturer-error').remove();
    }

    if (ValidForm) {
      if (document.getElementById('asteriskID').style.visibility === 'visible' && !$('#AdvSearchParametricValueParametricsOption-1').val()) {
        this.instance.$submitButton.prop('disabled', true);
      } else {
        this.instance.$submitButton.prop('disabled', false);
      }
    } else {
      this.instance.$submitButton.prop('disabled', true);
    }

    let container = document.getElementById(this.$manufacturerList.attr('aria-owns'));
    let addAlert = true;
    if (container && $(container).css('display') !== 'none')
    {
      this.$manufacturerList.removeClass('is-invalid');
      this.$manufacturerList.attr('role', 'combobox');
      this.$manufacturerList.removeAttr('aria-describedby');
      this.SetActiveDescendents(this.$manufacturerList);
      addAlert = false;
    }

    this.$form.each(function() {
      if (addAlert) {
        var $formField = $(this).find('.is-invalid');
        if ($formField.length) {
          $formField.attr('role', 'alert');
        }
      }
      else {
        var $formField = $(this).find('.is-invalid');
        if ($formField.length) {
          if ($formField.attr('role') === 'alert')
            $formField.removeAttr('role');
        }
      }
      $formField = $(this).find('input[aria-autocomplete]:not(.is-invalid)');
      if ($formField.length) {
        $formField.attr('role','combobox');
      }
    });
  };

  sendAnalytics(label,
    event = config.analytics.eventTypes.Click,
    category = config.analytics.categoryTypes.AdvancedSearch,
    action = config.analytics.actions.Click) {
    let data = {
      'event': event,
      'category': category,
      'action': action,
      'label': label
    };

    Analytics.pushToEventFramework(data);
  }

  SetActiveDescendents($input) {
    var container = $input[0].suggestionsContainer;
    if (container) {
      let val = $input[0].value.trim();
      if (!val && $input !== this.$manufacturerList)
        $input.removeAttr('aria-activedescendant');
      else {
        let $selected = $(container).find('.autocomplete-selected');
        if ($selected && $selected.length) {
          $input.attr('aria-activedescendant', $selected[0].id);
          $input.removeAttr('aria-describedby');
          $selected.attr('aria-selected', true);
          container.setAttribute('aria-hidden', false);
        }
        else {
          for (var i = 0; i < container.children.length; i++) {
            let selectedVal = container.children[i].innerText.split('(')[0];
            let inputVal = val.split('(')[0];
            if (selectedVal.trim() === inputVal.trim()) {
              $(container.children[i]).addClass('autocomplete-selected');
              $input.attr('aria-activedescendant', container.children[i].id);
              $(container.children[i]).attr('aria-selected', true);
              container.setAttribute('aria-hidden', false);
            }
            else {
              $(container.children[i]).attr('aria-selected', false);
            }
          }
        }
      }
    }
  }

  initializeEvents() {

    this.chosenManufacturerArray = [];
    this.$categoryList.val('');
    this.$manufacturerList.val('');
    this.setLabels();
    this.instance.$form.validate().resetForm();
    this.loadAdvancedSearchLists();

    this.$advMoreParametrics.on('click', () => {
      this.onAdditionalParameters();
    });

    this.$clearManufacturer.on('click', () => {
      this.onManufactureListClear();
      this.resetStatusBoxes();
      this.sendAnalytics(config.analytics.labelTypes.ManufacturerAnalyticsClear, config.analytics.eventTypes.Click, config.analytics.categoryTypes.AdvancedSearch, config.analytics.actions.Click);
    });

    this.$clearManufacturerAutoComplete.on('click', () => {
      this.clearManufacturerAutoCompleteFunction();
      this.validateForm();
    });

    this.$includeManufacturerCheckbox.on('keydown', (e) => {
      if (e.keyCode === 13) {
        this.cancelEvent(e);
      }
    });

    this.$manufacturerList.on('keyup', (e) => {
      if (e.target.value.trim() === '') {
        if (e.keyCode !== 38 && e.keyCode !== 40)
          this.onManufactureListClear();
      }
      else {
        this.sendAnalytics(e.target.value, config.analytics.eventTypes.Click, config.analytics.categoryTypes.AdvancedSearch, config.analytics.actions.ManufacturerAnalyticsEnteredTerm);
        let that = this;
        let id = this.$manufacturerList[0].id;
        setTimeout(function() {
          that.SetActiveDescendents($('#' + id));
        }, 1);
      }
    });

    this.$clearCategory.on('click', () => {
      this.onClearCategory();
      this.sendAnalytics(config.analytics.labelTypes.CategoryAnalyticsClear, config.analytics.eventTypes.Click, config.analytics.categoryTypes.AdvancedSearch, config.analytics.actions.Click);
    });

    this.$clearCategoryAutoComplete.on('click', () => {
      this.$includeManufacturerCheckbox.prop('disabled', true);
      this.clearCategoryAutoCompleteFunction();
    });

    this.$clearCategoryAutoComplete.on('keydown', (e) => {
      if (e.keyCode === 13) {
        this.clearCategoryAutoCompleteFunction();
        this.$includeManufacturerCheckbox.prop('disabled', true);
      }
    });

    this.$clearManufacturerAutoComplete.on('keyup', (e) => {
      if (e.keyCode === 13) {
        this.clearManufacturerAutoCompleteFunction();
      }
    });

    this.$advMoreParametrics.on('keydown', (e) => {
      if (e.keyCode === 13) {
        e.preventDefault();
        this.onAdditionalParameters();
      }
    });


    this.$form.on('keyup change', 'input', () => {
      this.validateForm();
    });

    this.$form.on('keyup change', 'select', () => {
      this.validateForm();
    });

    this.$categoryList.on('keyup', (e) => {
      if (e.target.value.trim() === '') {
        this.onClearCategory();
        this.toggleCategoryAutoCompleteControls();
      } else {
        this.sendAnalytics(e.target.value, config.analytics.eventTypes.Click, config.analytics.categoryTypes.AdvancedSearch, config.analytics.actions.CategoryAnalyticsEnteredTerm);
        let that = this;
        let id = this.$categoryList[0].id;
        setTimeout(function() {
          that.SetActiveDescendents($('#' + id));
        }, 1);
        this.$clearCategoryAutoComplete.show();
        this.$arrowsCategoryAutoComplete.hide();
      }
    });

    this.$searchInStockCheckbox.on('click', () => {
      this.verifyManufacturerStatusFilter();
      this.sendAnalytics(config.analytics.labelTypes.InStock, config.analytics.eventTypes.Click, config.analytics.categoryTypes.AdvancedSearch, config.analytics.actions.Click);
    });

    this.$searchTopPurchasedCheckbox.on('click', () => {
      this.verifyManufacturerStatusFilter();
      this.sendAnalytics(config.analytics.labelTypes.TopPurchased, config.analytics.eventTypes.Click, config.analytics.categoryTypes.AdvancedSearch, config.analytics.actions.Click);
    });

    this.$searchTopSearchedCheckbox.on('click', () => {
      this.verifyManufacturerStatusFilter();
      this.sendAnalytics(config.analytics.labelTypes.TopSearched, config.analytics.eventTypes.Click, config.analytics.categoryTypes.AdvancedSearch, config.analytics.actions.Click);
    });

    this.$searchNewCheckbox.on('click', () => {
      this.verifyManufacturerStatusFilter();
      this.sendAnalytics(config.analytics.labelTypes.New, config.analytics.eventTypes.Click, config.analytics.categoryTypes.AdvancedSearch, config.analytics.actions.Click);
    });

    this.$includeManufacturerCheckbox.on('click', () => {
      if (this.$includeManufacturerCheckbox.prop('checked')) {
        this.$advancedSearchManufacturerContainer.show();
        this.$manufacturerList.focus();
        document.getElementById('asterisk').style.visibility = 'visible';
      }
      else {
        this.$advancedSearchManufacturerContainer.hide();
        document.getElementById('asterisk').style.visibility = 'hidden';
      }
      this.sendAnalytics(config.analytics.labelTypes.ManufacturerCheckbox, config.analytics.eventTypes.Click, config.analytics.categoryTypes.AdvancedSearch, config.analytics.actions.Click);
    });

    this.$form.submit((e) => {
      e.preventDefault();
      this.validator.form();
    });
  }

  toggleCategoryAutoCompleteControls() {
    this.$clearCategoryAutoComplete.toggle();
    this.$arrowsCategoryAutoComplete.toggle();
  }

  clearCategoryAutoCompleteFunction() {
    this.onClearCategory();
    this.sendAnalytics(config.analytics.labelTypes.CategoryAnalyticsClear, config.analytics.eventTypes.Click, config.analytics.categoryTypes.AdvancedSearch, config.analytics.actions.Click);
  }
  clearManufacturerAutoCompleteFunction() {
    this.onManufactureListClear();
    this.resetStatusBoxes();
    this.toggleManufacturerAutoCompleteControls();
    this.sendAnalytics(config.analytics.labelTypes.ManufacturerAnalyticsClear, config.analytics.eventTypes.Click, config.analytics.categoryTypes.AdvancedSearch, config.analytics.actions.Click);
  }
  onAdditionalParameters() {
    this.parametricElement++;
    this.createNewParametric();
    this.loadAdditionalParams();
    if (this.parametricElement > 1) {
      let prevId = 'ParametricsOption-' + (this.parametricElement - 1);
      let $prevParametricItemClear = this.$form.find('#ParametricItem' + prevId);
      let $prevParametricValueClear = this.$form.find('#ParametricValue' + prevId);
      $prevParametricItemClear.hide();
      $prevParametricValueClear.hide();
    }
    this.sendAnalytics(config.analytics.labelTypes.AdditionalParameter, config.analytics.eventTypes.Click, config.analytics.categoryTypes.AdvancedSearch, config.analytics.actions.Click);
  }

  onClearCategory() {
    this.$includeManufacturerCheckbox.prop('disabled', true);
    this.$categoryList.val('');
    this.setLabels();
    this.$clearCategory.hide();
    this.chosenCategory = '';
    document.getElementById('AdvParametricHint').style.display = 'block';
    for (let x = 1; x <= this.parametricElement; x++) {
      let id = 'ParametricsOption-' + x;
      let $paramValue = this.$form.find('#AdvSearchParametric' + id);
      if ($paramValue && $paramValue.autocomplete()) {
        $paramValue.autocomplete().dispose();
      }
      $paramValue = this.$form.find('#AdvSearchParametricValue' + id);
      if ($paramValue && $paramValue.autocomplete()) {
        $paramValue.autocomplete().dispose();
      }
      $('#' + id).remove();
    }
    this.parametricElement = 1;
    this.parametricValuesArr = [];
    this.$advMoreParametrics.hide();
    this.createNewParametric();
    let manufacturerValue = this.$manufacturerList.val();
    if (manufacturerValue === '') {
      this.updateManufacturerList(this.advancedSearchLists.manufacturerListItems);
      this.updateCategoryList(this.advancedSearchLists.categoryListItems);
    }
    this.verifyManufacturerStatusFilter();
    this.resetStatusBoxes();
    this.toggleCategoryAutoCompleteControls();
    this.validateForm();
  }

  resetStatusBoxes() {
    this.$searchInStockCheckbox.prop('disabled', true);
    this.$searchNewCheckbox.prop('disabled', true);
    this.$searchTopPurchasedCheckbox.prop('disabled', true);
    this.$searchTopSearchedCheckbox.prop('disabled', true);
  }

  setLabels() {
    this.$categoryLabel.text(pluraliseAndTranslate('productSearch', 'advancedSearchProductCategory'));
    this.$manufacturerLabel.text(pluraliseAndTranslate('productSearch', 'advancedSearchManufacturer'));
  }

  toggleManufacturerAutoCompleteControls() {
    this.$clearManufacturerAutoComplete.toggle();
    this.$arrowsManufacturerAutoComplete.toggle();
  }

  onManufactureListClear() {
    this.$manufacturerList.val('');
    this.chosenManufacturerArray = [];
    this.setLabels();
    this.$clearManufacturer.hide();
    let categoryValue = this.$categoryList.val();
    if (categoryValue === '') {
      this.updateManufacturerList(this.advancedSearchLists.manufacturerListItems);
      this.updateCategoryList(this.advancedSearchLists.categoryListItems);
    }
    if (this.$manufacturerList.val() === '' && this.$categoryList.val() !== '') {
      this.verifyManufacturerStatusFilter();
    }
    this.$manufacturerList.focus();
  }

  ajaxRequest(url, model) {

    if (model !== undefined && model !== null) {
      return $.ajax({
        data: $.param(utilities.addCustIpToDataObject(model.retrieveData()), true),
        dataType: 'json',
        url: url,
        context: document.body
      });
    } else {
      return $.ajax({
        dataType: 'json',
        url: url,
        context: document.body
      });
    }
  }

  loadAdditionalParams() {
    let id = 'ParametricsOption-' + this.parametricElement;
    let $paramValue = this.$form.find('#AdvSearchParametric' + id);
    this.parameterList = _.filter(this.parametricsFacets, (el) => (
      el.name !== 'Manufacturer_name' &&
      el.name !== 'Manufacture Type' &&
      el.name !== 'Category' &&
      el.name !== 'In Stock' &&
      el.name !== 'New' &&
      el.name !== 'promoGroup' &&
      !el.facetValues[0].selected
    ));

    let paramaterArray = $.map(this.parameterList, ((item) => { return { value: item.title, data: item.urlName }; }));
    paramaterArray.sort(this.compareSuggestionItem);
    $paramValue.autocomplete().setOptions({
      lookup: paramaterArray
    });
    $paramValue.focus();
  }

  loadFilteredManufacturersAndParametersResult() {
    let promise = this.ajaxRequest(config.urls.advancedSearch.advancedFilter, this.modelData);
    this.registerFilterRequest(promise);

    promise.done(response => {
      let id = 'ParametricsOption-1';
      let $paramValue = this.$form.find('#AdvSearchParametric' + id);
      let $parametricListText = this.$form.find('#ParametricLabel' + id);
      this.updatePartStatus(response);
      let manufacturerFacetList = _.find(response.data.facetContainer.facets, (el) => (el.name === 'Manufacturer_name'));
      this.parameterList = _.filter(response.data.facetContainer.facets, (el) => (el.name !== 'Manufacturer_name' && el.name !== 'Manufacture Type' && el.name !== 'Category' && el.name !== 'In Stock' && el.name !== 'New' && el.name !== 'promoGroup' && el.name !== 'Type'));
      if (manufacturerFacetList && manufacturerFacetList.facetValues) {
        let manufacturerArray = $.map(manufacturerFacetList.facetValues, ((item) => { return { value: item.title + ' (' + item.count + ')', data: item.name, name: item.name }; }));
        let paramaterArray = $.map(this.parameterList, ((item) => { return { value: item.title, data: item.urlName }; }));
        this.$manufacturerList.autocomplete().setOptions({
          lookup: manufacturerArray
        });
        paramaterArray.sort(this.compareSuggestionItem);
        $paramValue.autocomplete().setOptions({
          lookup: paramaterArray
        });
        $paramValue.prop('disabled', false);
        $parametricListText.removeClass(disabledLabel);
        this.$manufacturerList.prop('disabled', false);
      }
    });

    promise.fail(() => {
      this.filterCount = this.filterCount;
    });
  }

  createNewParametric() {
    let id = 'ParametricsOption-' + this.parametricElement;
    let prevId = 'ParametricsOption-' + (this.parametricElement - 1);
    let data = { paramId: id };
    this.$parametricValues.append(parametricValue(data));

    let $paramValue = this.$form.find('#AdvSearchParametric' + id);
    let $paramValueArray = this.$form.find('#AdvSearchParametricValue' + id);
    let $parametricListText = this.$form.find('#ParametricLabel' + id);
    let $parametricItemClear = this.$form.find('#ParametricItem' + id);
    let $parametricValueListText = this.$form.find('#ParametricValueLabel' + id);
    let $parametricValueList = this.$form.find('#AdvSearchParametricValue' + id);
    let $parametricOperator = this.$form.find('#AdvSearchParametricOperatorValue' + id);

    let $prevParametricItemClear = this.$form.find('#ParametricItem' + prevId);
    let $prevParametricItemValueClear = this.$form.find('#ParametricValue' + prevId);

    let $clearParametericItem = this.$form.find('#ClearParametricItem' + id);
    let $arrowsParametericItem = this.$form.find('#ArrowsParametricItem' + id);

    $clearParametericItem.hide();
    $arrowsParametericItem.show();
    this.$form.find('#submit').attr('disabled', false);

    $paramValue.autocomplete({
      minLength: 0,
      minChars: 0,
      autoSelectFirst: false,
      zIndex: 10000,
      lookupFilter: ((suggestion, originalQuery, queryLowerCase) => {
        let re = new RegExp('\\b' + $.Autocomplete.utils.escapeRegExChars(queryLowerCase), 'gi');
        return re.test(suggestion.value);
      }),
      onSelect: ((suggestion) => {
        this.chosenParametric = suggestion.data;
        let parametric = _.find(this.parameterList, (el) => (el.title === suggestion.value));
        let parametricValueArray = $.map(parametric.facetValues, ((item) => { return { value: item.title + ' (' + item.count + ')', data: item.name }; }));
        parametricValueArray.sort(this.compareSuggestionItem);
        $paramValueArray.autocomplete().setOptions({
          lookup: parametricValueArray
        });
        $parametricOperator.prop('disabled', false);
        $paramValueArray.prop('disabled', false);
        $parametricValueListText.removeClass(disabledLabel);

        document.getElementById('asteriskID').style.visibility = 'visible';
        if (document.getElementById('asteriskID').style.visibility === 'visible' && !$paramValueArray.val()) {
          this.$form.find('#submit').attr('disabled', true);
        }
        $clearParametericItem.show();
        $arrowsParametericItem.hide();
        this.sendAnalytics(suggestion.value, config.analytics.eventTypes.Click, config.analytics.categoryTypes.AdvancedSearch, config.analytics.actions.ParameterAnalyticsSelectedTerm);
      }),
      onHint: ((hint) => {
        $('#AdvSearchParametricx' + id).val(hint);
      }),
      onHide: (() => {
        $('#AdvSearchParametric' + id).removeAttr('aria-activedescendant');
        $('#AdvSearchParametric' + id).removeAttr('aria-describedby');
        $('#AdvSearchParametric' + id).attr('aria-expanded', false);
      }),
      beforeRender: ((container) => {
        container[0].id = 'AdvSearchParametricAutocomplete' + id;
        container.attr('role', 'listbox');
        container.attr('aria-hidden', true);
      }),
      onSearchComplete: (() => {
        try {
          let container = document.getElementById($('#AdvSearchParametric' + id).attr('aria-owns'));
          if (container) {
            for (var i = 0; i < container.children.length; i++) {
              container.children[i].id = container.id + '' + i;
              container.children[i].setAttribute('role', 'option');
            }
            $('#AdvSearchParametric' + id)[0].suggestionsContainer = container;
            $('#AdvSearchParametric' + id).attr('aria-expanded', true);
          }
          this.chosenParametric = $paramValue.autocomplete().suggestions[0].data;
        } catch (e) {
          console.log(e.message);
        }
      })
    });
    $paramValue.attr('aria-autocomplete', 'list');
    $paramValue.attr('role', 'combobox');
    $paramValue.attr('aria-expanded', false);
    $paramValue.attr('aria-owns', 'AdvSearchParametricAutocomplete' + id);
    $paramValue.on('keyup', (e) => {
      e.stopPropagation();
      this.sendAnalytics(e.target.value, config.analytics.eventTypes.Click, config.analytics.categoryTypes.AdvancedSearch, config.analytics.actions.ParameterAnalyticsEnteredTerm);
      this.SetActiveDescendents($paramValue);
    });

    if (this.parametricElement > 1) {
      $paramValueArray.prop('disabled', false);
      $parametricValueListText.removeClass(disabledLabel);
      document.getElementById('asteriskID').style.visibility = 'visible';
      this.$advMoreParametrics.hide();
    } else {
      $paramValue.prop('disabled', true);
      $parametricListText.addClass(disabledLabel);
    }

    $parametricItemClear.on('click', () => {
      if (this.parametricElement === 1) {
        $paramValue.val('');
        $paramValueArray.val('');
        $paramValueArray.prop('disabled', true);
        $clearParametericItem.hide();
        $arrowsParametericItem.show();
      } else {
        this.parametricElement--;
        if ($parametricValueList.val()) {
          this.parametricValuesArr.pop();
        }
        if ($paramValue && $paramValue.autocomplete()) {
          $paramValue.autocomplete().dispose();
        }
        $('#' + id).remove();

        $prevParametricItemClear.show();
        $prevParametricItemValueClear.show();
        this.$advMoreParametrics.show();
      }
      this.sendAnalytics(config.analytics.labelTypes.ParameterAnalyticsClear, config.analytics.eventTypes.Click, config.analytics.categoryTypes.AdvancedSearch, config.analytics.actions.Click);
    });

    $clearParametericItem.on('click', (event) => {
      this.clearParametericItemFunction(event);
      setTimeout(() => {
        let id = 'ParametricsOption-' + this.parametricElement;
        let $paramValue = this.$form.find('#AdvSearchParametric' + id);
        $paramValue.focus();
      }, 500);
      this.validateForm();
    });
    $clearParametericItem.on('keydown', (event) => {
      if (event.keyCode === 13) {
        setTimeout(() => {
          let id = 'ParametricsOption-' + this.parametricElement;
          let $paramValue = this.$form.find('#AdvSearchParametric' + id);
          $paramValue.focus();
        }, 500);
        this.clearParametericItemFunction(event);
        this.validateForm();
      }
    });

    this.createParametricValueAutocomplete($paramValueArray);
  }
  clearParametericItemFunction(event) {
    //Get current parameter id
    let id = 'ParametricsOption-' + this.parametricElement;
    let $parametricValueList = this.$form.find('#AdvSearchParametricValue' + id);
    const targetParamId = event.target.getAttribute('data-id');
    const currentParamId = Number(targetParamId.substring(targetParamId.indexOf('-') + 1, targetParamId.length));
    //Remove all subsequent parameters
    for (let x = this.parametricElement; x >= currentParamId; x--) {
      if (this.parametricElement > 0) {
        if ($parametricValueList.val()) {
          this.parametricValuesArr.splice(x - 1, 1);
        }
        const id = 'ParametricsOption-' + x;
        const $paramItemValue = this.$form.find('#AdvSearchParametric' + id);
        if ($paramItemValue && $paramItemValue.autocomplete()) {
          $paramItemValue.autocomplete().dispose();
        }
        $('#' + id).remove();
        this.parametricElement--;
      }
    }

    //If its parameters mimic clear all category parametric
    if (currentParamId === 1) {
      //Reset elements state
      this.parametricValuesArr = [];
      this.parametricElement = 1;
      this.createNewParametric();
      this.loadFilteredManufacturersAndParametersResult();
      this.$advMoreParametrics.hide();
    } else {
      this.$advMoreParametrics.show();
      this.chosenParametricValue = null;
      this.updateParametricValueArray();
    }
    this.sendAnalytics(config.analytics.labelTypes.ParameterAnalyticsClear, config.analytics.eventTypes.Click, config.analytics.categoryTypes.AdvancedSearch, config.analytics.actions.Click);

  }
  createParametricValueAutocomplete($paramValueAutocomplete) {

    let id = 'ParametricsOption-' + this.parametricElement;
    let $parametricOperator = this.$form.find('#AdvSearchParametricOperatorValue' + id);
    let $parametricValueList = this.$form.find('#AdvSearchParametricValue' + id);
    let $parametricValueListText = this.$form.find('#ParametricValueLabel' + id);
    let $parametricItemValueClear = this.$form.find('#ParametricValue' + id);

    let $clearParametricItemValue = this.$form.find('#ClearParametricValue' + id);
    let $arrowsParametricItemValue = this.$form.find('#ArrowsParametricValue' + id);

    $clearParametricItemValue.hide();
    $arrowsParametricItemValue.show();

    $paramValueAutocomplete.autocomplete({
      minLength: 0,
      minChars: 0,
      autoSelectFirst: false,
      zIndex: 10000,
      lookupFilter: ((suggestion, originalQuery, queryLowerCase) => {
        let re = new RegExp('\\b' + $.Autocomplete.utils.escapeRegExChars(queryLowerCase), 'gi');
        return re.test(suggestion.value);
      }),
      onSelect: ((suggestion) => {
        $clearParametricItemValue.show();
        $arrowsParametricItemValue.hide();
        this.chosenParametricValue = suggestion.data;

        if (this.chosenParametricValue) {
          this.$form.find('#submit').attr('disabled', false);
        }

        this.updateParametricValueArray();
        this.sendAnalytics(suggestion.value, config.analytics.eventTypes.Click, config.analytics.categoryTypes.AdvancedSearch, config.analytics.actions.ParameterValueAnalyticsSelectedTerm);
      }),
      onHint: ((hint) => {
        $('#AdvSearchParametricValuex' + id).val(hint);
      }),
      onHide: (() => {
        $('#AdvSearchParametricValue' + id).removeAttr('aria-activedescendant');
        $('#AdvSearchParametricValue' + id).removeAttr('aria-describedby');
        $('#AdvSearchParametricValue' + id).attr('aria-expanded', false);
      }),
      beforeRender: ((container) => {
        container[0].id = 'AdvSearchParametricValueAutocomplete' + id;
        container.attr('role', 'listbox');
        container.attr('aria-hidden', true);
      }),
      onSearchComplete: (() => {
        try {
          let container = document.getElementById($('#AdvSearchParametricValue' + id).attr('aria-owns'));
          if (container) {
            for (var i = 0; i < container.children.length; i++) {
              container.children[i].id = container.id + '' + i;
              container.children[i].setAttribute('role', 'option');
            }
            $('#AdvSearchParametricValue' + id)[0].suggestionsContainer = container;
            $('#AdvSearchParametricValue' + id).attr('aria-expanded', true);
          }
          this.chosenParametricValue = $paramValueAutocomplete.autocomplete().suggestions[0].data;
        } catch (e) {
          console.log(e.message);
        }
      })
    });
    $paramValueAutocomplete.attr('aria-autocomplete', 'list');
    $paramValueAutocomplete.attr('role', 'combobox');
    $paramValueAutocomplete.attr('aria-expanded', false);
    $paramValueAutocomplete.attr('aria-owns', 'AdvSearchParametricValueAutocomplete' + id);
    $paramValueAutocomplete.on('keyup', (e) => {
      this.sendAnalytics(e.target.value, config.analytics.eventTypes.Click, config.analytics.categoryTypes.AdvancedSearch, config.analytics.actions.ParameterValueAnalyticsEnteredTerm);
      this.SetActiveDescendents($paramValueAutocomplete);
    });
    let parametricOperatorArray = this.getParametricOperatorList();

    $parametricOperator.autocomplete({
      minLength: 0,
      minChars: 0,
      zIndex: 10000,
      lookup: parametricOperatorArray,
      autoSelectFirst: false,
      onSelect: ((suggestion) => {
        $clearParametricItemValue.show();
        $arrowsParametricItemValue.hide();
        this.chosenParametricOperator = suggestion.data;
        this.updateParametricValueArray();
      }),
      onHint: ((hint) => {
        $('#AdvSearchParametricOperatorValuex' + id).val(hint);
      })
    });

    $parametricItemValueClear.on('click', () => {
      this.parametricValuesArr.pop();
      $parametricValueList.val('');
      $parametricOperator.val('');
      this.chosenParametricValue = null;
      this.chosenParametricOperator = null;
      this.$advMoreParametrics.hide();
      $parametricItemValueClear.hide();
      this.sendAnalytics(config.analytics.labelTypes.ParameterValueAnalyticsClear, config.analytics.eventTypes.Click, config.analytics.categoryTypes.AdvancedSearch, config.analytics.actions.Click);
    });

    $clearParametricItemValue.on('click', (event) => {
      const targetParamId = event.target.getAttribute('data-id');
      const currentParamId = Number(targetParamId.substring(targetParamId.indexOf('-') + 1, targetParamId.length));
      let id = 'ParametricsOption-' + currentParamId;
      let $paramValuefocus = this.$form.find('#AdvSearchParametricValue' + id);
      $paramValuefocus.focus();
      this.clearParametricItemValueFuntion(event);
    });

    $clearParametricItemValue.on('keydown', (event) => {
      if (event.keyCode === 13) {
        const targetParamId = event.target.getAttribute('data-id');
        const currentParamId = Number(targetParamId.substring(targetParamId.indexOf('-') + 1, targetParamId.length));
        let id = 'ParametricsOption-' + currentParamId;
        let $paramValuefocus = this.$form.find('#AdvSearchParametricValue' + id);
        $paramValuefocus.focus();
        this.clearParametricItemValueFuntion(event);
      }
    });

    $parametricOperator.prop('disabled', true);
    $parametricValueList.prop('disabled', true);
    $parametricValueListText.addClass(disabledLabel);
    this.$form.find('#submit').attr('disabled', true);
  }

  clearParametricItemValueFuntion(event) {
    //Get current parameter id
    const targetParamId = event.target.getAttribute('data-id');
    const currentParamId = Number(targetParamId.substring(targetParamId.indexOf('-') + 1, targetParamId.length));
    let id = 'ParametricsOption-' + currentParamId;
    const $clearParametricItemValue = this.$form.find('#ClearParametricValue' + id);
    let $parametricValueList = this.$form.find('#AdvSearchParametricValue' + id);
    let $parametricOperator = this.$form.find('#AdvSearchParametricOperatorValue' + id);
    const $arrowsParametricItemValue = this.$form.find('#ArrowsParametricValue' + id);

    //Set the chosen parametric to current parametric
    if (this.parametricValuesArr.length > 0) {
      const currentParametric = this.parametricValuesArr[currentParamId - 1];
      if (currentParametric) {
        this.chosenParametric = currentParametric.parametric;
      }
    }
    //Remove all subsequent parameters
    for (let x = this.parametricElement; x > currentParamId; x--) {
      if (this.parametricElement > 1) {
        if ($parametricValueList.val()) {
          this.parametricValuesArr.splice(x - 1, 1);
        }
        const id = 'ParametricsOption-' + x;
        const $paramItemValue = this.$form.find('#AdvSearchParametric' + id);
        if ($paramItemValue && $paramItemValue.autocomplete()) {
          $paramItemValue.autocomplete().dispose();
        }
        $('#' + id).remove();
        this.parametricElement--;
      }
    }
    this.parametricValuesArr.pop();
    $parametricValueList.val('');
    $parametricOperator.val('');
    this.chosenParametricValue = null;
    this.chosenParametricOperator = null;

    if (this.chosenParametricValue === null && this.chosenParametricOperator === null) {
      this.$form.find('#submit').attr('disabled', true);
    }

    this.$advMoreParametrics.hide();
    $clearParametricItemValue.hide();
    $arrowsParametricItemValue.show();
    this.sendAnalytics(config.analytics.labelTypes.ParameterValueAnalyticsClear, config.analytics.eventTypes.Click, config.analytics.categoryTypes.AdvancedSearch, config.analytics.actions.Click);
  }

  updateParametricValueArray() {
    if (this.parametricValuesArr.length > 0) {
      let lastSelected = this.parametricValuesArr[this.parametricValuesArr.length - 1];
      if (lastSelected && this.chosenParametricValue !== null && (lastSelected.parametricValue !== this.chosenParametricValue || lastSelected.parametricOperator !== this.chosenParametricOperator)) {
        this.parametricValuesArr.push({
          parametric: this.chosenParametric,
          parametricValue: this.chosenParametricValue,
          parametricOperator: this.chosenParametricOperator
        });
      }
    } else if (this.chosenParametricValue) {
      this.parametricValuesArr.push({
        parametric: this.chosenParametric,
        parametricValue: this.chosenParametricValue,
        parametricOperator: this.chosenParametricOperator
      });
    }
    this.verifyManufacturerStatusFilter(true);
  }

  getParametricOperatorList() {
    let parametricOperatorArray = [];
    parametricOperatorArray.push({ value: '=', data: 'Equal' });
    parametricOperatorArray.push({ value: '>=', data: 'GreaterThanOrEqual' });
    parametricOperatorArray.push({ value: '<=', data: 'LessThanOrEqual' });
    parametricOperatorArray.push({ value: '>', data: 'GreaterThan' });
    parametricOperatorArray.push({ value: '<', data: 'LessThan' });

    return parametricOperatorArray;
  }

  compareSuggestionItem(a, b) {
    if (a.value.toLowerCase() < b.value.toLowerCase()) {
      return -1;
    }
    if (a.value.toLowerCase() > b.value.toLowerCase()) {
      return 1;
    }
    return 0;
  }

  loadFilteredParametersResult() {
    let promise = this.ajaxRequest(config.urls.advancedSearch.advancedFilter, this.modelData);
    this.registerFilterRequest(promise);

    promise.done(response => {
      this.updatePartStatus(response);
      this.parameterList = _.filter(response.data.facetContainer.facets, (el) => (el.name !== 'Manufacturer_name' && el.name !== 'Manufacture Type' && el.name !== 'Category' && el.name !== 'In Stock' && el.name !== 'New' && el.name !== 'eurohs' && el.name !== 'promoGroup' && el.name !== 'Type'));
      let paramaterArray = $.map(this.parameterList, ((item) => { return { value: item.title, data: item.urlName }; }));
      paramaterArray.sort(this.compareSuggestionItem);
      this.$parametricList.autocomplete().setOptions({
        lookup: paramaterArray
      });

      this.$parametricList.prop('disabled', false);
      this.$parametricListText.removeClass(disabledLabel);
    });

    promise.fail(() => {
      this.filterCount = this.filterCount;
    });
  }

  loadFilteredCategoryResult(chosenManufacturerId) {
    let promise = this.ajaxRequest(config.urls.advancedSearch.advancedCategoriesForManufacturers + chosenManufacturerId, null);
    this.$categoryList.prop('disabled', true);
    this.registerFilterRequest(promise);

    promise.done(response => {
      let categoryList = response.data;
      let categoryArray = $.map(categoryList, ((item) => { return { value: item.categoryName + ' (' + item.productCount + ')', data: item.categoryId, name: item.categoryName }; }));
      this.$categoryList.autocomplete().setOptions({
        lookup: categoryArray
      });
      this.$categoryList.prop('disabled', false);
    });

    promise.fail(() => {
      this.filterCount = this.filterCount;
    });
  }

  loadAdvancedSearchLists() {
    if (this.advancedSearchLists !== undefined && this.advancedSearchLists !== null) {
      this.updateManufacturerList(this.advancedSearchLists.manufacturerListItems);
      this.updateCategoryList(this.advancedSearchLists.categoryListItems);
    }
    else {
      let promise = this.ajaxRequest(config.urls.advancedSearch.advancedSearchLists, null);
      this.$manufacturerList.prop('disabled', true);
      this.registerFilterRequest(promise);

      promise.done(response => {
        this.advancedSearchLists = response.data;
        this.updateManufacturerList(this.advancedSearchLists.manufacturerListItems);
        this.updateCategoryList(this.advancedSearchLists.categoryListItems);

        this.$categoryList.prop('disabled', false);
        this.$manufacturerList.prop('disabled', false);
      });

      promise.fail(() => {
        this.filterCount = this.filterCount;
      });
    }
  }

  createRequestQuery() {
    let statusFilterModel = new UrlDataModel({ apiUrlString: 'q=' + '&cat=' + this.chosenCategory + this.setPartFilters() });
    if (this.chosenCategoryType === '3') {
      statusFilterModel = new UrlDataModel({ apiUrlString: 'q=' + '&prodLine=' + this.chosenCategory + this.setPartFilters() });
    }

    if (this.isManufacturerSearch()) {
      let manufacturerName = this.chosenManufacturerArray[0].name;

      //Handle encoding of '&' other characters will be encoded by using Jquery.Params function
      manufacturerName = manufacturerName.replace('&', '%26');

      let searchUrl = 'q=' +
        manufacturerName +
        config.events.search.filterString +
        config.events.search.manufacturerFilter +
        manufacturerName +
        ';' +
        this.setPartFilters() +
        config.events.search.manufacturerType;
      statusFilterModel = new UrlDataModel({ apiUrlString: searchUrl });
    }

    return statusFilterModel;
  }

  verifyManufacturerStatusFilter(verifyAdditionalParametrics) {
    let promise = this.ajaxRequest(config.urls.advancedSearch.advancedFilter, this.createRequestQuery());
    promise.done(response => {
      if (response && response.data && response.data.facetContainer) {
        let manufacturerFacetList = _.find(response.data.facetContainer.facets, (el) => (el.name === 'Manufacturer_name'));
        if (manufacturerFacetList && manufacturerFacetList.facetValues && manufacturerFacetList.facetValues.length >= 1) {
          let manufacturerArray = $.map(manufacturerFacetList.facetValues, ((item) => { return { value: item.title + ' (' + item.count + ')', data: item.name, name: item.name }; }));
          this.$manufacturerList.autocomplete().setOptions({
            lookup: manufacturerArray
          });
        }

        if (verifyAdditionalParametrics && this.parametricElement < this.maxParams) {
          if (response && response.data && response.data.facetContainer && response.data.facetContainer.facets && this.parametricElement < response.data.facetContainer.facets.length) {
            this.parametricsFacets = _.filter(response.data.facetContainer.facets, (el) => (el.name !== 'Manufacturer_name' && el.name !== 'Manufacture Type' && el.name !== 'Category' && el.name !== 'In Stock' && el.name !== 'New' && el.name !== 'promoGroup' && el.name !== 'Type'));
            this.$advMoreParametrics.show();
          } else {
            this.$advMoreParametrics.hide();
          }
        }
      }
      this.updatePartStatus(response);
    });

    promise.fail(() => {
      this.updatePartStatus([]);
    });
  }

  setPartStatusInStockCheckBox(enable) {
    if (enable) {
      this.$searchInStockCheckbox.prop('disabled', false);
      this.$searchInStockCheckbox.parent('label').removeClass(disabledLabel);
    } else {
      this.$searchInStockCheckbox.prop('checked', false);
      this.$searchInStockCheckbox.prop('disabled', true);
      this.$searchInStockCheckbox.parent('label').addClass(disabledLabel);
    }
  }

  setPartStatusNewCheckBox(enable) {
    if (enable) {
      this.$searchNewCheckbox.prop('disabled', false);
      this.$searchNewCheckbox.parent('label').removeClass(disabledLabel);
    } else {
      this.$searchNewCheckbox.prop('checked', false);
      this.$searchNewCheckbox.prop('disabled', true);
      this.$searchNewCheckbox.parent('label').addClass(disabledLabel);
    }
  }

  setPartStatusTopSearchedCheckBox(enable) {
    if (enable) {
      this.$searchTopSearchedCheckbox.prop('disabled', false);
      this.$searchTopSearchedCheckbox.parent('label').removeClass(disabledLabel);
    } else {
      this.$searchTopSearchedCheckbox.prop('checked', false);
      this.$searchTopSearchedCheckbox.prop('disabled', true);
      this.$searchTopSearchedCheckbox.parent('label').addClass(disabledLabel);
    }
  }

  setPartStatusTopPurchasedCheckBox(enable) {
    if (enable) {
      this.$searchTopPurchasedCheckbox.prop('disabled', false);
      this.$searchTopPurchasedCheckbox.parent('label').removeClass(disabledLabel);
    } else {
      this.$searchTopPurchasedCheckbox.prop('checked', false);
      this.$searchTopPurchasedCheckbox.prop('disabled', true);
      this.$searchTopPurchasedCheckbox.parent('label').addClass(disabledLabel);
    }
  }

  updatePartStatus(response) {

    let inStockCheckBoxStatus = false;
    let topPurchasedCheckBoxStatus = false;
    let topSearchedCheckBoxStatus = false;
    let newCheckBoxStatus = false;
    if (response && response.data && response.data.facetContainer) {
      let promoGroups = _.filter(response.data.facetContainer.facets, (el) =>
        (el.name === 'promoGroup')
      );

      let instockItems = _.filter(response.data.facetContainer.facets, (el) =>
        (el.name === 'In Stock')
      );

      let newItems = _.filter(response.data.facetContainer.facets, (el) =>
        (el.name === 'New')
      );

      newCheckBoxStatus = newItems.length > 0;
      inStockCheckBoxStatus = instockItems.length > 0;

      if (promoGroups && promoGroups.length > 0 && promoGroups[0]) {
        let topPurchased = _.filter(promoGroups[0].facetValues, (el) => (el.name === 'Top Purchased'));
        let topSearched = _.filter(promoGroups[0].facetValues, (el) => (el.name === 'Top Searched'));

        topPurchasedCheckBoxStatus = topPurchased.length > 0;
        topSearchedCheckBoxStatus = topSearched.length > 0;
      }
    }
    this.setPartStatusInStockCheckBox(inStockCheckBoxStatus);
    this.setPartStatusNewCheckBox(newCheckBoxStatus);
    this.setPartStatusTopPurchasedCheckBox(topPurchasedCheckBoxStatus);
    this.setPartStatusTopSearchedCheckBox(topSearchedCheckBoxStatus);
  }

  updateManufacturerList(source) {
    let manufacturerArray = $.map(source, ((item) => { return { value: item.manufacturerName + ' (' + item.count + ')', data: item.manufacturerId, name: item.manufacturerName }; }));
    this.$manufacturerList.autocomplete().setOptions({
      lookup: manufacturerArray
    });
  }

  updateCategoryList(source) {
    let categoryArray = $.map(source, ((item) => {
      let subCategoryArray = _.filter(source, (subItem) => (
        subItem.parentCategoryName && subItem.parentCategoryName === item.searchParameter
      ));
      return { value: '' + item.title + ' (' + item.productCount + ')', data: item.searchParameter, name: item.title, categoryType: item.categoryType, dependentSuggestions: subCategoryArray, title: item.title };
    }));
    this.$categoryList.autocomplete().setOptions({
      lookup: categoryArray
    });
  }

  registerFilterRequest(jqXHR) {
    if (this.filterXhr) {
      this.filterXhr.abort();
    }

    this.filterXhr = jqXHR;

    // Clear the filterXhr when its completed
    jqXHR.always(() => this.filterXhr = false);
  }

  getValidatorConfig() {
    return {
      errorClass: config.classes.isInvalid,
      validClass: config.classes.isValid,
      errorElement: 'span',
      rules: {
        searchTerm: {
          require_from_group: [1, config.classes.advancedSearchValidationGroup]
        },
        AdvSearchCategoriesCategory: {
          require_from_group: [1, config.classes.advancedSearchValidationGroup]
        },
        AdvSearchCategoriesManufacturer: {
          require_from_manufacture: [1, config.classes.advancedSearchValidationGroup]
        }
      },
      errorPlacement: (error, element) => {
        $(`#${error[0].id}`).remove();
        if (element.attr('name') === 'AdvSearchCategoriesCategory') {
          error.insertAfter('.AdvancedCategory');
        } else if (element.attr('name') === 'AdvSearchCategoriesManufacturer') {
          error.insertAfter('.AdvancedManufacturer');
        } else {
          element.removeAttr('aria-label');
          error.insertAfter(element);
          error.setAttribute('aria-hidden', true);
        }
        $('span.is-invalid').addClass('error-message-icon');
      },
      submitHandler: () => {
        if (this.chosenCategory === undefined || this.chosenCategory === '' && this.$categoryList.val()) {
          this.chosenCategory = this.$categoryList.autocomplete().suggestions[0].data;
        }
        this.updateParametricValueArray();
        if (this.chosenManufacturerArray.length < 1 &&  this.$manufacturerList.val()) {
          this.chosenManufacturerArray.push(this.$manufacturerList.autocomplete().suggestions[0]);
        }
        this.sendAnalytics(config.analytics.labelTypes.ApplyAdvancedSearch);
        Analytics.setOnDataLayer({ search: { advancedSearch: true } });

        let searchText = this.$searchTextBox.val() || '';
        let searchUrl = config.urls.searchWithQueryPage + searchText + this.setCategoryFilter() + this.setPartFilters();
        if (this.isManufacturerSearch()) {
          let arrayString = [];
          if (this.chosenManufacturerArray.length > 0) {
            let tempArray = _.pluck(this.chosenManufacturerArray, 'name');
            arrayString = tempArray.join('|');
            arrayString = arrayString.replace(' ', '+');
            arrayString = arrayString.replace('&', '%26');
          }

          let manufacturerName = this.chosenManufacturerArray[0].name;
          searchUrl = config.urls.searchWithQueryPage +
            encodeURIComponent(manufacturerName) +
            config.events.search.filterString +
            config.events.search.manufacturerFilter +
            arrayString +
            ';' +
            this.setPartFilters() +
            config.events.search.manufacturerType;
        }
        window.location.href = searchUrl;
      },
      invalidHandler: () => {
        return false;
      }
    };
  }

  isManufacturerSearch() {
    let searchText = this.$searchTextBox.val();
    let manufacturerNameArray = this.chosenManufacturerArray;
    let categoryName = this.$categoryList.val();
    return manufacturerNameArray.length > 0 && (searchText === undefined || searchText === '') && categoryName === '';
  }

  createValidator() {
    this.validator = this.$form.validate(this.getValidatorConfig()); //set up validation rules
  }

  setCategoryFilter() {
    let categoryName = '&cat=' + this.chosenCategory;
    if (this.chosenCategoryType === '3') {
      categoryName = '&prodLine=' + this.chosenCategory;
    }
    return categoryName;
  }

  setPartFilters() {
    let inStock = this.$searchInStockCheckbox.prop('checked') ? true : false;
    let topPurchased = this.$searchTopPurchasedCheckbox.prop('checked') ? true : false;
    let topSearched = this.$searchTopSearchedCheckbox.prop('checked') ? true : false;
    let newProduct = this.$searchNewCheckbox.prop('checked') ? true : false;
    let manufacturerNameArray = this.chosenManufacturerArray;

    let manufacturerFilterParameter = '';
    let partStatusFilter = '';
    let selectedFilters = '';
    let endOfString = ';';
    let concatValue = '|';

    if (inStock || topPurchased || topSearched) {
      if (partStatusFilter === '' && !this.isManufacturerSearch()) {
        partStatusFilter = config.events.search.promoGroupString + config.events.search.filterString;
      }

      if (topPurchased || topSearched) {
        partStatusFilter = partStatusFilter + config.events.search.promoGroup;
      }

      if (topPurchased) {
        if (selectedFilters === '') {
          selectedFilters = selectedFilters + config.events.search.topPurchased;
        } else {
          selectedFilters = selectedFilters + concatValue + config.events.search.topPurchased;
        }
      }

      if (topSearched) {
        if (selectedFilters === '') {
          selectedFilters = selectedFilters + config.events.search.topSearched;
        } else {
          selectedFilters = selectedFilters + concatValue + config.events.search.topSearched;
        }
      }

      if (inStock) {
        if (topSearched || topPurchased) {
          selectedFilters = selectedFilters + endOfString;
        }
        selectedFilters = selectedFilters + config.events.search.inStockValue;
      }

      selectedFilters = selectedFilters + endOfString;
    }

    partStatusFilter = partStatusFilter + selectedFilters;

    if (newProduct) {
      if (partStatusFilter === '' && !this.isManufacturerSearch()) {
        partStatusFilter = config.events.search.promoGroupString + config.events.search.filterString;
      }
      partStatusFilter = partStatusFilter + config.events.search.newValueFilter;
    }

    if (manufacturerNameArray.length > 0 && !this.isManufacturerSearch()) {
      if (partStatusFilter === '') {
        partStatusFilter = config.events.search.filterString;
      }

      let tempArray = _.pluck(manufacturerNameArray, 'name');
      let arrayString = tempArray.join('|');
      arrayString = arrayString.replace(' ', '+');
      manufacturerFilterParameter = encodeURIComponent(config.events.search.manufacturerFilter + arrayString + endOfString);
    }

    let parametricsFilters = '';

    _.each(this.parametricValuesArr, (paramValue) => {
      if (paramValue.parametricOperator) {
        parametricsFilters = parametricsFilters + decodeURIComponent(paramValue.parametric) + ':' + paramValue.parametricValue + ':' + paramValue.parametricOperator + endOfString;
      } else {
        parametricsFilters = parametricsFilters + decodeURIComponent(paramValue.parametric) + ':' + paramValue.parametricValue + endOfString;
      }
    });

    if (partStatusFilter === '' && parametricsFilters !== '') {
      partStatusFilter = config.events.search.filterString;
    }

    if (parametricsFilters.indexOf('|') > 0) {
      parametricsFilters = encodeURI(parametricsFilters);
    }

    partStatusFilter = partStatusFilter + parametricsFilters;

    return encodeURI(partStatusFilter) + manufacturerFilterParameter;
  }

  cancelEvent(e) {
    e = e || window.event;
    if (e !== null) {
      if (e.cancelBubble) {
        e.cancelBubble = true;
      }
      e.preventDefault();
      if (e.stopPropagation) {
        e.stopPropagation();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./assets/components/Header/js/AdvancedSearchController.js